import React from 'react'
let PropTypes = React.PropTypes

export class InputOkSei extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            valor: this.props.inventario.inv_aprobacionSEI,
            facturado: this.props.inventario.inv_facturado
        }
        this.cambioCheckbox = (evt)=>{
            let estado = evt.target.checked
            this.finalizarEdicion(estado)
            evt.preventDefault()
            this.setState({
                valor: estado
            })
        }
        this.finalizarEdicion = (estado)=>{
            this.props.aprobacionSei(this.props.inventario.inv_idInventario, estado)
        }
    }
    componentWillReceiveProps(nextProps){
        // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
        this.setState({
            valor: nextProps.inventario.inv_aprobacionSEI
        })
    }
    render(){
        return (
            <input
                type="checkbox"
                checked={this.state.valor}
                onChange={this.cambioCheckbox.bind(this)}
                disabled={this.state.facturado}
            />
        )
    }
}
InputOkSei.propTypes = {
    inventario: PropTypes.object
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/InputOkSei.jsx